(function(){
  function initCollection(root){
    if(!root||root.dataset.ppCollectionReady==='true')return;
    root.dataset.ppCollectionReady='true';
    var cards=Array.from(root.querySelectorAll('[data-pp-product-card]'));
    var count=root.querySelector('[data-pp-result-count]');
    var empty=root.querySelector('[data-pp-filter-empty]');
    if(count)count.textContent=String(cards.length);
    root.querySelectorAll('[data-pp-filter]').forEach(function(button){
      button.addEventListener('click',function(){
        var filter=button.dataset.ppFilter||'all';
        var visible=0;
        root.querySelectorAll('[data-pp-filter]').forEach(function(item){
          var active=item===button;
          item.classList.toggle('is-active',active);
          item.setAttribute('aria-pressed',active?'true':'false');
        });
        cards.forEach(function(card){
          var groups=' '+(card.dataset.ppGroups||'')+' ';
          var show=filter==='all'||groups.indexOf(' '+filter+' ')!==-1;
          card.hidden=!show;
          if(show)visible+=1;
        });
        if(count)count.textContent=String(visible);
        if(empty)empty.hidden=visible!==0;
      });
    });
  }

  function initRails(scope){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    scope.querySelectorAll('[data-pp-auto-rail]').forEach(function(rail){
      if(rail.dataset.ppRailReady==='true')return;
      rail.dataset.ppRailReady='true';
      var pausedUntil=0;
      var timer;
      function pause(){pausedUntil=Date.now()+9000;}
      rail.addEventListener('pointerdown',pause,{passive:true});
      rail.addEventListener('wheel',pause,{passive:true});
      rail.addEventListener('focusin',pause);
      if(!('IntersectionObserver' in window))return;
      new IntersectionObserver(function(entries,observer){
        if(!entries[0].isIntersecting){if(timer){window.clearInterval(timer);timer=null;}return;}
        if(timer)return;
        timer=window.setInterval(function(){
          if(Date.now()<pausedUntil||rail.scrollWidth<=rail.clientWidth+8)return;
          var first=rail.firstElementChild;
          var step=first?first.getBoundingClientRect().width+10:Math.min(rail.clientWidth*.78,340);
          var end=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-10;
          rail.scrollTo({left:end?0:rail.scrollLeft+step,behavior:'smooth'});
        },3800);
      },{threshold:.35}).observe(rail);
    });
  }

  function initReveals(scope){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(!('IntersectionObserver' in window))return;
    var targets=scope.querySelectorAll('.pp-home>section:not(.pp-hero),.pp-collection-v19>section,.ppx>section:not(.ppx-top)');
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },{threshold:.08,rootMargin:'0px 0px -30px'});
    targets.forEach(function(target){target.classList.add('pp-reveal-v19');observer.observe(target);});
  }

  function initSticky(root){
    if(!root||root.dataset.ppStickyReady==='true')return;
    root.dataset.ppStickyReady='true';
    var panel=root.querySelector('[data-ppx-buy-panel]');
    var sticky=root.querySelector('[data-ppx-sticky]');
    var stickyPrice=root.querySelector('[data-ppx-sticky-price]');
    var sourcePrice=root.querySelector('[data-ppx-price]');
    var stickyBuy=root.querySelector('[data-ppx-sticky-buy]');
    var stickyAdd=root.querySelector('[data-ppx-sticky-add]');
    var sourceAdd=root.querySelector('.ppx-add');
    if(!panel||!sticky)return;
    function syncPrice(){if(stickyPrice&&sourcePrice)stickyPrice.textContent=sourcePrice.textContent;}
    function setVisible(visible){sticky.classList.toggle('is-visible',visible);sticky.setAttribute('aria-hidden',visible?'false':'true');}
    syncPrice();
    if(sourcePrice&&'MutationObserver' in window)new MutationObserver(syncPrice).observe(sourcePrice,{childList:true,characterData:true,subtree:true});
    root.addEventListener('change',function(){window.requestAnimationFrame(syncPrice);});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){setVisible(!entries[0].isIntersecting&&entries[0].boundingClientRect.top<0);},{threshold:.05}).observe(panel);
    }
    if(stickyAdd)stickyAdd.addEventListener('click',function(){if(sourceAdd)sourceAdd.click();});
    if(stickyBuy)stickyBuy.addEventListener('click',function(){
      var payment=root.querySelector('.ppx-buy-now .shopify-payment-button__button,.ppx-buy-now button[type="button"],.ppx-buy-now button[type="submit"]');
      if(payment){payment.click();return;}
      panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
    });
  }

  function init(scope){
    initCollection(scope.querySelector('[data-pp-collection]'));
    initRails(scope);
    initReveals(scope);
    initSticky(scope.querySelector('[data-ppx-root]'));
  }

  function boot(){init(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
